
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Income product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Income' subtitle='API reference for Income endpoints and webhooks' compact mdxType="Header" />
    <p>{`Verify a user's income via payroll or bank account data. For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/income/"
      }}>{`Income documentation`}</a>{`.`}</p>
    <div className="long-endpoint-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Endpoints`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/sessions/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Get Link session metadata and results for the end user`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/bank_income/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information from the bank accounts used for income verification`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/bank_income/pdf/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information from the bank accounts used for income verification in PDF format`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/bank_statements/uploads/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information from the bank statements used for income verification`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/payroll_income/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Retrieve information from the pay stubs or tax forms used for income verification`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/payroll_income/risk_signals/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Analyze uploaded income documents for indications of potential fraud`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/payroll_income/parsing_config/update`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Update the parsing configuration for a document verification`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/employment/get`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`(beta) Retrieve employment information about the end user`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`/credit/payroll_income/refresh`}</inlineCode></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`(beta) Retrieve updated payroll income data on a linked account`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/income/fire_webhook`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Manually fire an Income webhook (Sandbox only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/user/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create a user for use with the income verification product`}</td>
        </tr>
      </tbody>
    </table>
    <div className="long-endpoint-table">
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Webhooks`}</th>
            <th parentName="tr" {...{
              "align": null
            }}></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#user_income_verification"
              }}><inlineCode parentName="a">{`USER_INCOME_VERIFICATION`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Income verification has completed`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#user_income_verification_risk_signals"
              }}><inlineCode parentName="a">{`USER_INCOME_VERIFICATION_RISK_SIGNALS`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Risk evaluation of user-uploaded documents has completed`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#user_income_verification_refresh_reconnect_needed"
              }}><inlineCode parentName="a">{`USER_INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`A Payroll Income verification could not be refreshed`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#income_verification"
              }}><inlineCode parentName="a">{`INCOME_VERIFICATION`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Income verification has completed (legacy)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#income_verification_risk_signals"
              }}><inlineCode parentName="a">{`INCOME_VERIFICATION_RISK_SIGNALS`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Risk evaluation of user-uploaded documents has completed (legacy)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}><a parentName="td" {...{
                "href": "#income_verification_refresh_reconnect_needed"
              }}><inlineCode parentName="a">{`INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED`}</inlineCode></a></td>
            <td parentName="tr" {...{
              "align": null
            }}>{`A Payroll Income verification could not be refreshed (legacy)`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "usercreate"
    }}>{`/user/create`}</h4>
    <Schema method='POST' route='/user/create' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/user/create' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: UserCreateRequest = {
  client_user_id: 'c0e2c4ee-b763-4af5-cfe9-46a46bce883d',
};

try {
  const response = await client.userCreate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/user/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "client_user_id": "c0e2c4ee-b763-4af5-cfe9-46a46bce883d"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::UserCreateRequest.new(
  {
    client_user_id: 'c0e2c4ee-b763-4af5-cfe9-46a46bce883d'
  }
)

response = client.user_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`UserCreateRequest request = new UserCreateRequest()
  .clientUserId("c0e2c4ee-b763-4af5-cfe9-46a46bce883d");

Response<UserCreateResponse> response = client
  .userCreate(request, null)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = UserCreateRequest(
  client_user_id='c0e2c4ee-b763-4af5-cfe9-46a46bce883d'
)

response = client.user_create(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewUserCreateRequest(
  "c0e2c4ee-b763-4af5-cfe9-46a46bce883d",
)

response, _, err := client.PlaidApi.UserCreate(ctx).UserCreateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.UserCreateRequest{ClientUserID: "c0e2c4ee-b763-4af5-cfe9-46a46bce883d"}

response, err := client.User.Create(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/user/create' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditsessionsget"
    }}>{`/credit/sessions/get`}</h4>
    <Schema method='POST' route='/credit/sessions/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/sessions/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditSessionsGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditSessionsGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/sessions/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditSessionsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.credit_sessions_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditSessionsGetRequest request = new CreditSessionsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditSessionsGetResponse> response = client
  .creditSessionsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditSessionsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.credit_sessions_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditSessionsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditSessionsGet(ctx).CreditSessionsGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditSessionsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.GetSessions(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/sessions/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditbank_incomeget"
    }}>{`/credit/bank_income/get`}</h4>
    <Schema method='POST' route='/credit/bank_income/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/bank_income/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditBankIncomeGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
  options: {
    count: 1,
  },
};

try {
  const response = await client.creditBankIncomeGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/bank_income/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "options": {
    "count": 1
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditBankIncomeGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    options: {
      count: 1
    }
  }
)
response = client.credit_bank_income_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditBankIncomeGetRequestOptions options = new CreditBankIncomeGetRequestOptions()
  .count(1);

CreditBankIncomeGetRequest request = new CreditBankIncomeGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .options(options);

Response<CreditBankIncomeGetResponse> response = client
  .creditBankIncomeGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditBankIncomeGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  options=CreditBankIncomeGetRequestOptions(
    count=1
  )
)

response = client.credit_bank_income_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`options := plaid.NewCreditBankIncomeGetRequestOptions()
options.SetCount(1)

request := plaid.NewCreditBankIncomeGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")
request.SetOptions(*options)

response, _, err := client.PlaidApi.CreditBankIncomeGet(ctx).CreditBankIncomeGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`options := &plaid.CreditBankIncomeGetRequestOptions{}
options.Count = plaid.Int(1)

request := &plaid.CreditBankIncomeGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")
request.Options = options

response, err := client.Credit.GetBankIncome(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/bank_income/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditbank_incomepdfget"
    }}>{`/credit/bank_income/pdf/get`}</h4>
    <Schema method='POST' route='/credit/bank_income/pdf/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/bank_income/pdf/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditBankIncomePDFGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditBankIncomePdfGet(request, {
    responseType: 'arraybuffer',
  });
  const pdf = response.data.toString('base64');
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/bank_income/pdf/get \\
 -H 'Content-Type: application/json' \\
 -d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
 }' \\
 -o 'bank_income.pdf'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditBankIncomePDFGetRequest.new({ user_id: 'usr_9nSp2KuZ2x4JDw' })
response = client.credit_bank_income_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditBankIncomePDFGetRequest request = new CreditBankIncomePDFGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<ResponseBody> response = client()
  .creditBankIncomePdfGet(request)
  .execute();
byte[] pdf = response.body().bytes();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditBankIncomePDFGetRequest(user_id='usr_9nSp2KuZ2x4JDw')
pdf = client.credit_bank_income_pdf_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditBankIncomePDFGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditBankIncomePdfGet(ctx).CreditBankIncomePDFGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditBankIncomePdfGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.GetBankIncomePdf(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <h5 {...{
      "id": "response"
    }}>{`Response`}</h5>
    <p>{`This endpoint returns binary PDF data. `}<a parentName="p" {...{
        "href": "https://plaid.com/documents/sample-bank-income.pdf"
      }}>{`View a sample Bank Income PDF.`}</a></p>
    <h4 {...{
      "id": "creditbank_statementsuploadsget"
    }}>{`/credit/bank_statements/uploads/get`}</h4>
    <Schema method='POST' route='/credit/bank_statements/uploads/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/bank_statements/uploads/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditBankStatementsUploadsGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditBankStatementsUploadsGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/bank_statements/uploads/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "\${USER_ID}"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditBankStatementsUploadsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
  }
)
response = client.credit_bank_statements_uploads_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditBankStatementsUploadsGetRequest request = new CreditBankStatementsUploadsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditBankStatementsUploadsGetResponse> response = client
  .creditBankStatementsUploadsGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditBankStatementsUploadsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.credit_bank_statements_uploads_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditBankStatementsUploadsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditBankStatementsUploadsGet(ctx).CreditBankStatementsUploadsGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditBankStatementsUploadsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.GetBankStatementsUploads(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/bank_statements/uploads/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditpayroll_incomeget"
    }}>{`/credit/payroll_income/get`}</h4>
    <Schema method='POST' route='/credit/payroll_income/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/payroll_income/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditPayrollIncomeGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditPayrollIncomeGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/payroll_income/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditPayrollIncomeGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.credit_payroll_income_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditPayrollIncomeGetRequest request = new CreditPayrollIncomeGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditPayrollIncomeGetResponse> response = client
  .creditPayrollIncomeGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditPayrollIncomeGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.credit_payroll_income_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditPayrollIncomeGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditPayrollIncomeGet(ctx).CreditPayrollIncomeGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditPayrollIncomeGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.GetPayrollIncome(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/payroll_income/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditpayroll_incomerisk_signalsget"
    }}>{`/credit/payroll_income/risk_signals/get`}</h4>
    <Schema method='POST' route='/credit/payroll_income/risk_signals/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/payroll_income/risk_signals/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/payroll_income/risk_signals/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditPayrollIncomeRiskSignalsGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};
try {
  const response = await client.creditPayrollIncomeRiskSignalsGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditPayrollIncomeRiskSignalsGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
)
response = client.credit_payroll_income_risk_signals_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditPayrollIncomeRiskSignalsGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
  }
)
response = client.credit_payroll_income_risk_signals_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditPayrollIncomeRiskSignalsGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")
response, _, err := client.PlaidApi.CreditPayrollIncomeRiskSignalsGet(ctx).CreditPayrollIncomeRiskSignalsGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditPayrollIncomeRiskSignalsGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")
response, err := client.Credit.GetPayrollIncomeRiskSignals(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditPayrollIncomeRiskSignalsGetRequest request = new CreditPayrollIncomeRiskSignalsGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditPayrollIncomeRiskSignalsGetResponse> response = client
  .creditPayrollIncomeRiskSignalsGet(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/payroll_income/risk_signals/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditemploymentget"
    }}>{`/credit/employment/get`}</h4>
    <Schema method='POST' route='/credit/employment/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/employment/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditEmploymentGetRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditEmploymentGet(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/employment/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw"
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditEmploymentGetRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)
response = client.credit_employment_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditEmploymentGetRequest request = new CreditEmploymentGetRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditEmploymentGetResponse> response = client
  .creditEmploymentGet(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditEmploymentGetRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.credit_employment_get(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditEmploymentGetRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditEmploymentGet(ctx).CreditEmploymentGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditEmploymentGetRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.GetEmployment(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/employment/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditpayroll_incomeparsing_configupdate"
    }}>{`/credit/payroll_income/parsing_config/update`}</h4>
    <Schema method='POST' route='/credit/payroll_income/parsing_config/update' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/payroll_income/parsing_config/update' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/payroll_income/parsing_config/update \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "parsing_config": ["ocr"]
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditPayrollIncomeParsingConfigUpdateRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
  parsing_config: ['ocr'],
};
try {
  const response = await client.creditPayrollIncomeParsingConfigUpdate(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditPayrollIncomeParsingConfigUpdateRequest(
  user_id='usr_9nSp2KuZ2x4JDw',
  parsing_config=[IncomeVerificationDocParsingConfig('ocr')]
)
response = client.credit_payroll_income_parsing_config_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditPayrollIncomeParsingConfigUpdateRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw',
    parsing_config: ['ocr'],
  }
)
response = client.credit_payroll_income_parsing_config_update(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditPayrollIncomeParsingConfigUpdateRequest(
  []plaid.IncomeVerificationDocParsingConfig{plaid.INCOMEVERIFICATIONDOCPARSINGCONFIG_OCR},
)
request.SetUserId("usr_9nSp2KuZ2x4JDw")
response, _, err := client.PlaidApi.CreditPayrollIncomeParsingConfigUpdate(ctx).CreditPayrollIncomeParsingConfigUpdateRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditPayrollIncomeParsingConfigUpdateRequest{
    ParsingConfig: []plaid.IncomeVerificationDocParsingConfig{plaid.IncomeVerificationDocParsingConfigOcr},
}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")
response, err := client.Credit.UpdatePayrollIncomeParsingConfig(ctx, request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditPayrollIncomeParsingConfigUpdateRequest request = new CreditPayrollIncomeParsingConfigUpdateRequest()
  .userId("usr_9nSp2KuZ2x4JDw")
  .parsingConfig(Arrays.asList(IncomeVerificationDocParsingConfig.OCR));

Response<CreditPayrollIncomeParsingConfigUpdateResponse> response = client
  .creditPayrollIncomeParsingConfigUpdate(request)
  .execute();
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/payroll_income/parsing_config/update' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "creditpayroll_incomerefresh"
    }}>{`/credit/payroll_income/refresh`}</h4>
    <Schema method='POST' route='/credit/payroll_income/refresh' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/credit/payroll_income/refresh' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: CreditPayrollIncomeRefreshRequest = {
  user_id: 'usr_9nSp2KuZ2x4JDw',
};

try {
  const response = await client.creditPayrollIncomeRefresh(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/credit/payroll_income/refresh \\
-H 'Content-type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "user_id": "usr_9nSp2KuZ2x4JDw",
  "options": {
    "item_ids": [
      "eVBnVMp7zdTJLkRNr33Rs6zr7KNJqBFL9DrE6"
    ]
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::CreditPayrollIncomeRefreshRequest.new(
  {
    user_id: 'usr_9nSp2KuZ2x4JDw'
  }
)

response = client.credit_payroll_income_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`CreditPayrollIncomeRefreshRequest request = new CreditPayrollIncomeRefreshRequest()
  .userId("usr_9nSp2KuZ2x4JDw");

Response<CreditPayrollIncomeRefreshResponse> response = client
  .creditPayrollIncomeRefresh(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = CreditPayrollIncomeRefreshRequest(
  user_id='usr_9nSp2KuZ2x4JDw'
)

response = client.credit_payroll_income_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewCreditPayrollIncomeRefreshRequest()
request.SetUserId("usr_9nSp2KuZ2x4JDw")

response, _, err := client.PlaidApi.CreditPayrollIncomeRefresh(ctx).CreditPayrollIncomeRefreshRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.CreditPayrollIncomeRefreshRequest{}
request.UserID = plaid.String("usr_9nSp2KuZ2x4JDw")

response, err := client.Credit.RefreshPayrollIncome(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/credit/payroll_income/refresh' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <p>{`Income webhooks are sent to indicate when an income verification or document fraud risk evaluation has finished processing.`}</p>
    <h4 {...{
      "id": "user_income_verification"
    }}><inlineCode parentName="h4">{`USER_INCOME_VERIFICATION`}</inlineCode></h4>
    <Schema type='model' model='UserIncomeVerificationStatusWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "user_income_verification_risk_signals"
    }}><inlineCode parentName="h4">{`USER_INCOME_VERIFICATION_RISK_SIGNALS`}</inlineCode></h4>
    <Schema type='model' model='UserIncomeVerificationRiskSignalsStatusWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "user_income_verification_refresh_reconnect_needed"
    }}><inlineCode parentName="h4">{`USER_INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED`}</inlineCode></h4>
    <Schema type='model' model='UserIncomeVerificationRefreshReconnectNeededWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "income_verification"
    }}><inlineCode parentName="h4">{`INCOME_VERIFICATION`}</inlineCode></h4>
    <Schema type='model' model='IncomeVerificationStatusWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "income_verification_risk_signals"
    }}><inlineCode parentName="h4">{`INCOME_VERIFICATION_RISK_SIGNALS`}</inlineCode></h4>
    <Schema type='model' model='IncomeVerificationRiskSignalsStatusWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "income_verification_refresh_reconnect_needed"
    }}><inlineCode parentName="h4">{`INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED`}</inlineCode></h4>
    <Schema type='model' model='IncomeVerificationRefreshReconnectNeededWebhook' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "usercreate",
        level: 4,
        title: "/user/create",
      },
{
        id: "creditsessionsget",
        level: 4,
        title: "/credit/sessions/get",
      },
{
        id: "creditbank_incomeget",
        level: 4,
        title: "/credit/bank_income/get",
      },
{
        id: "creditbank_incomepdfget",
        level: 4,
        title: "/credit/bank_income/pdf/get",
      },
{
        id: "creditbank_statementsuploadsget",
        level: 4,
        title: "/credit/bank_statements/uploads/get",
      },
{
        id: "creditpayroll_incomeget",
        level: 4,
        title: "/credit/payroll_income/get",
      },
{
        id: "creditpayroll_incomerisk_signalsget",
        level: 4,
        title: "/credit/payroll_income/risk_signals/get",
      },
{
        id: "creditemploymentget",
        level: 4,
        title: "/credit/employment/get",
      },
{
        id: "creditpayroll_incomeparsing_configupdate",
        level: 4,
        title: "/credit/payroll_income/parsing_config/update",
      },
{
        id: "creditpayroll_incomerefresh",
        level: 4,
        title: "/credit/payroll_income/refresh",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "user_income_verification",
        level: 4,
        title: "USER_INCOME_VERIFICATION",
      },
{
        id: "user_income_verification_risk_signals",
        level: 4,
        title: "USER_INCOME_VERIFICATION_RISK_SIGNALS",
      },
{
        id: "user_income_verification_refresh_reconnect_needed",
        level: 4,
        title: "USER_INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED",
      },
{
        id: "income_verification",
        level: 4,
        title: "INCOME_VERIFICATION",
      },
{
        id: "income_verification_risk_signals",
        level: 4,
        title: "INCOME_VERIFICATION_RISK_SIGNALS",
      },
{
        id: "income_verification_refresh_reconnect_needed",
        level: 4,
        title: "INCOME_VERIFICATION_REFRESH_RECONNECT_NEEDED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
